module.exports = __webpack_public_path__ + "mo/img/ic_nav.2fa362f7.svg";